
// Crypto replacements.
import sha256 from 'crypto-js/sha256';
import { base64UrlEncode } from '../util/base64'

import * as settings from '../globals/settings';

const cryptoRandomString = require('crypto-random-string');

// Config!
const host = settings.DIGITAL_ID_API_URL;
const clientId = settings.DIGITAL_ID_CLIENT_ID;
const redirectUri = settings.DIGITAL_ID_REDIRECT_URI;

const baseUrl = host;
const authorizeUrl = baseUrl + 'authorization.oauth2';
const tokenUrl = baseUrl + 'token.oauth2';
const endSessionUrl = baseUrl + 'connect/endSession';

// Digital id settings. DO NOT ALTER
// FIXME The top commented scopes are the recommended ones, but they are not set up.
//const scopes = 'openid%20did_health%20profile';
const scopes = 'openid did_health';
const challengeMethod ='S256'; // We are sha256ing the codeVerifier


export function endSession(authorizationToken) {
    let finalUrl = endSessionUrl + '?id_token_hint=' + authorizationToken;
    console.log("FINAL URL LOGOUT: " + finalUrl);
    return fetch(encodeURI(finalUrl)).then((response) => { 
        console.log("RAW LOGOUT RESPONSE: " + JSON.stringify(response));
        if (!response.ok) {
            throw Error("Logout Failed.");
        }
        return response
    }).then((response) => {
        var resp = {};
        resp.success = true;
        resp.message = "";
        return resp;
    }).catch((error) => { 
        var resp = {};
        resp.success = false;
        resp.message = error.message;
        return resp;
    });
}

export async function generateAuthorizeUrl() {
    // Generate required parameters.
    try {
        let nonce = await generateNonce();
        let codeVerifier = await generateCodeVerifier();
        let state = await generateState();
        let codeChallenge = await generateCodeChallenge(codeVerifier);
        
        console.log("CODE VERIFIER: " + JSON.stringify(codeVerifier));

        let url = authorizeUrl + '?client_id=' + clientId + '&response_type=code&scope=' + scopes + '&redirect_uri=' + encodeURIComponent(redirectUri);
        url += '&nonce=' + nonce;
        //url += '&code_challenge=' + codeChallenge
        //url += '&code_challenge_method=' + challengeMethod
        //url += '&state=' + state;
        console.log("Authorize url: " + url);
        // Sendthese back for storage
        let openIdVars = {
            authorizeUrl: url,
            codeVerifier: codeVerifier,
            state: state,
            nonce: nonce,
            codeChallenge: codeChallenge,
        }
        return openIdVars;
    } catch (err) {
        console.log("ERR??");
        return null;
    }
}

// Nonce variable is to verify that id token received at the end is from this authorize request.
// Should be random string.
async function generateNonce() {
    try {
        let str = await generateRandomString(8);
		return base64UrlEncode(str);
    } catch (e) {
        console.log("Error", e.message);
        return null;
    }
}

// State variable is to prevent XSRF
// Verify this is the same once we get it back as part of the redirect uri
async function generateState() {
    try {
        let str = await generateRandomString(8);
        return base64UrlEncode(str);
    } catch (e) {
        console.log("Error", e.message);
        return null;
    }
}

// PKCE FUNCTIONS
// Reference: https://auth0.com/docs/api-auth/tutorials/authorization-code-grant-pkce

// Take sha256 of code verifier and b64 it.
async function generateCodeChallenge(verifier) {
    return base64UrlEncode(await sha256(verifier));
}

// Generate random string and b64 it
async function generateCodeVerifier() {
    try {
        let str = await generateRandomString(32);
        return base64UrlEncode(str);
    } catch (e) {
        console.log("Error", e.message);
        return null;
    }
}

async function generateRandomString(len) {
    try {
        let str = await cryptoRandomString({length: len, type: 'base64'});
        return str;
    } catch (e) {
        console.log("Error", e.message);
    }
}

// Parsing redirectUri functions
// Error format:
// mylabs://lab.gnb.ca/redirect#error_description=Response%20type%20is%20not%20supported.&error=unsupported_response_type
export function parseOpenIdError(url) {
    console.log("authorization return url: " + url);
    let errorDescription = null;
    let error = null
    let errorState = checkErrorState(url);
    if (errorState == true) {
        errorDescription = parseErrorDescription(url);
        error = parseError(url);
    }
    let data = {errorState: errorState, errorDescription: errorDescription, error: error};
    return data;
}

function checkErrorState(url) {
    let regex = /^.*?error_description=(.*)&error=.*#.$/
    let test = regex.test(url);
    return test;
}

function parseErrorDescription(url) {
    let regex = /^.*?error_description=(.*)&error=.*#.$/
    let data = url.match(regex);
    return data[1];
}

function parseError(url) {
    let regex = /^.*?error_description=.*&error=(.*)#.$/
    let data = url.match(regex);
    return data[1];
}

//Format: mylabs://lab.gnb.ca/redirect?code=4799e235-9764-4dde-ad01-db9dd77b9607&scope=did_health%20openid%20did_profile&iss=https%3A%2F%2Fuat.id.gnb.ca%2Fsso%2Foauth2%2Fgnb&state=77-9DiJ-WjPvv73vv70&client_id=MyLabsUAT
export function parseOpenIdUrl(url) {
    let code = parseCode(url);
    //let state = parseState(url);
    //let data = { code : code, state: state }
    let data = { code : code }
    return data;
}

function parseAccessToken(url) {
    let regex = /^.*#access_token=(.*)&code.*$/
    let data = url.match(regex);
    return data[1];
}

function parseState(url) {
    let regex = /^.*&state=(.*)&client_id=.*$/
    let data = url.match(regex);
    return data[1];
}

function parseCode(url) {
    //let regex = /^.*code=(.*)&scope=.*$/
    let regex = /^.*code=(.*)$/
    let data = url.match(regex);
    return data[1];
}

function parseExpiry(url) {
    let regex = /^.*&expires_in=([0-9]+)&client_id.*$/
    let data = url.match(regex);
    return data[1];
}

    /*module.exports = {
    generateAuthorizeUrl: generateAuthorizeUrl,
    parseOpenIdUrl: parseOpenIdUrl,
    parseOpenIdError: parseOpenIdError,
    endSession: endSession,
}*/
